export default __webpack_public_path__ + "static/media/V9hvNFF9-overlay-lights.c88eb557.svg";